import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomerAddOnsDialogComponent } from './customer-add-ons-dialog.component';
import { MainPipe } from '../../pipes/pipes.module';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { LoadingModule } from '../../loading/loading.module';

@NgModule({
  declarations: [CustomerAddOnsDialogComponent],
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatCheckboxModule,
    MatButtonModule,
    MatIconModule,
    MainPipe,
    LoadingModule,
  ],
})
export class CustomerAddOnsDialogModule {}
